import { Global, css } from '@emotion/react';

export const GlobalStyles = () => (
  <Global
    styles={css`
      :root {
        --error-color: #ef4444;
        --app-safe-area-top: env(safe-area-inset-top, 0px);
        --app-safe-area-right: env(safe-area-inset-right, 0px);
        --app-safe-area-bottom: env(safe-area-inset-bottom, 0px);
        --app-safe-area-left: env(safe-area-inset-left, 0px);
        --app-safe-area-viewport-height: max(0px, calc(
          100svh - var(--app-safe-area-top) - var(--app-safe-area-bottom)
        ));
      }

      html,
      body {
        margin: 0;
        padding: 0;
        min-height: 100%;
        /* Hide scrollbar for Firefox */
        scrollbar-width: none;
        /* Hide scrollbar for IE and Edge */
        -ms-overflow-style: none;
      }

      /* Hide scrollbar for Chrome, Safari and Opera */
      html::-webkit-scrollbar,
      body::-webkit-scrollbar {
        display: none;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      /* Hide scrollbar globally for all elements */
      * {
        scrollbar-width: none;
        -ms-overflow-style: none;
      }

      *::-webkit-scrollbar {
        display: none;
      }

      body {
        font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }

      #root {
        min-height: 100dvh;
        background: #ffffff;
        color: #1c1c1e;
      }

      /* Global fade transition */
      .fade-enter-active,
      .fade-leave-active {
        transition: opacity 0.18s ease;
      }
      .fade-enter-from,
      .fade-leave-to {
        opacity: 0;
      }

      .error-message {
        color: var(--error-color);
        font-size: 16px;
        line-height: 125%;
        letter-spacing: 0%;
        text-align: center;
      }
    `}
  />
);
